export interface SupplierAvatarProps {
  name: string;
  /** Logo URL (e.g. "/logos/graham.png"); falls back to initials when absent. */
  logo?: string | null;
  /** Diameter override in px (POC default is 34). */
  size?: number;
}

/** Initials fallback matching the POC's `supplierInitials` logic. */
export function supplierInitials(name: string): string {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part.charAt(0))
      .join("")
      .slice(0, 3)
      .toUpperCase() || name
  );
}

export function SupplierAvatar({ name, logo, size }: SupplierAvatarProps) {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <span className="supplier-avatar" title={name} style={style}>
      {logo ? <img src={logo} alt={`${name} logo`} /> : supplierInitials(name)}
    </span>
  );
}
